<template>
	<div>
		<div class="main">
			<div class="wrapper">
				<a class="main_content">
					<div class="main_text">
						<div class="main_heading">ВАШ ПУТЕВОДИТЕЛЬ<br>В МИРЕ СПОРТА</div>
						<a href="/subscribe" class="main_button">Подписаться</a>
					</div>
				</a>
			</div>
		</div>
		
		<div v-if="showBlock()" class="main-mobile-simple">
			<video autoplay :src="'/video/' +  getVideo()" loop muted></video>
		</div>
		
		<div class="main-mobile-block" v-else>
			<img src="/img/main-mobile.jpg" alt="">
		</div>
		
		<!--<a href="https://w.kassa.rambler.ru/event/53121263/233f47e9-c7bb-4077-8020-5d2679af1e8f/%2F/" class="main-mobile" v-else>
			<video autoplay :src="'/video/main.mp4'" loop muted></video>
			
			<div class="wrapper">
				<div class="main-mobile_row">
					<div class="main-mobile_image">
						<img width="90" src="/img/logo-1.png" alt="">
					</div>
					
					<div class="main-mobile_text" style="text-shadow: 0 0 2px #000">VS</div>
					
					<div class="main-mobile_image">
						<img width="75" src="/img/logo-2.png" alt="">
					</div>
				</div>
				
				<div class="main-mobile_time" style="text-shadow: 0 0 2px #000">среда, 4 марта в 19:30</div>
				
				<button class="main-mobile_button">Купить билет</button>
			</div>
		</a>-->
	</div>
</template>

<script>
	export default {
		props: ['type'],
		
		methods: {
			getVideo() {
				if (this.showBlock()) {
					return 'main-' + this.type + '.mp4'
				}
				return 'main';
			},
			showBlock() {
				return this.type === 'basketball' || this.type === 'volleyball' || this.type === 'mma';
			}
		}
	}
</script>